module.exports = __webpack_public_path__ + "img/microneedling.d3143308.svg";